import FileCopyIcon from "@material-ui/icons/FileCopy"
import React from "react"
import values from "~/const.scss"

const DuplicateIcon = () => <FileCopyIcon style={{ color: values.darkPurple }} />

export default DuplicateIcon
